import { logoutServiceClient } from '@/helpers/environmentHelper';
import { logToServer } from '@/services/LogService';
import { getAuthMetadata } from '@/services/UserService';
import { useAppSelector } from '@/state/hooks';
import { selectCredentials } from '@/state/reducers/authSlice';
import { useCallback, useEffect, useMemo } from 'react';
import { isMobile } from 'react-device-detect';
import { useLocation } from 'react-router';

const EventListeners = () => {
    const location = useLocation();
    const credentials = useAppSelector(selectCredentials);

    const shouldLogout = useMemo(() => !['/login', '/forgot-password'].includes(location.pathname), [location]);

    const handleBeforeUnload = useCallback(
        async (event) => {
            try {
                if (credentials && shouldLogout) {
                    await logoutServiceClient.unary.logout({}, getAuthMetadata(credentials));
                    logToServer(
                        'info',
                        `User [${credentials.username}] has been logged out due to beforeunload event.`
                    );
                }
            } catch (err) {
                console.log(err);
            }
            setTimeout(() => {
                event.preventDefault();
            }, 100);
        },
        [shouldLogout]
    );

    const handleVisibilityChange = useCallback(
        async (event) => {
            if (isMobile) {
                try {
                    if (credentials && shouldLogout) {
                        await logoutServiceClient.unary.logout({}, getAuthMetadata(credentials));
                        logToServer(
                            'info',
                            `User [${credentials.username}] has been logged out due to visibilitychange event.`
                        );
                    }
                } catch (err) {
                    console.log(err);
                }
                setTimeout(() => {
                    event.preventDefault();
                }, 100);
            }
        },
        [shouldLogout]
    );

    useEffect(() => {
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [handleBeforeUnload]);

    useEffect(() => {
        window.addEventListener('visibilitychange', handleVisibilityChange);
        return () => {
            window.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [handleVisibilityChange]);

    return null;
};

export default EventListeners;

// code snippet from celer

// useCallback(async zt=>{
//     try {
//         await logoutCall()
//     } catch (Zt) {
//         Network.Error(Zt)
//     }
//     Ut({
//         type: ActionTypes$f.LOGOUT_RESPONSE
//     }),
//     setTimeout(()=>{
//         zt.preventDefault()
//     }
//     , 100)
